<template>
  <content-show-dialog
    :fullHeight="false"
    :registerId="dialogProperties.rowData.id"
    :model="dialogProperties.rowData.model"
  >
    <div slot="info" class="card border-0 mb-0">
      <info-table
        :infoColumns="dialogProperties.tableColumns"
        :infoData="{
          ...dialogProperties.rowData,
          effectTags: dialogProperties.effectTags,
        }"
        :showBusinesses="dialogProperties.showBusinessesTag"
        :showModules="dialogProperties.showModulesTag"
        :showSubcategories="dialogProperties.showSubcategoriesTag"
      >
        <template slot="addColumn" v-if="dialogProperties.addColumns">
          <tr
            class="shadow-sm"
            v-for="(addColumn, key) in dialogProperties.addColumns"
            :key="`${key}-${addColumn.label}`"
          >
            <td-info-tag
              :data="dialogProperties.rowData[addColumn.data]"
              :tdLabel="`${addColumn.label}:`"
              :fieldTag="addColumn.field"
              :effect="dialogProperties.effectTags"
            />
          </tr>
        </template>
      </info-table>
      <footer-date-at
        style="margin: 0 -15px -15px -15px"
        :createdAt="dialogProperties.rowData.created_at"
        :updatedAt="dialogProperties.rowData.updated_at"
        :createdUser="dialogProperties.rowData.created_user"
        :updatedUser="dialogProperties.rowData.updated_user"
      />
    </div>
  </content-show-dialog>
</template>
<script>
import InfoTable from 'src/components/Tables/InfoTable.vue';
import TdInfoTag from 'src/components/Tables/TdInfoTag.vue';

export default {
  name: 'show-as-dialog',
  components: {
    [InfoTable.name]: InfoTable,
    [TdInfoTag.name]: TdInfoTag,
  },
  props: {
    dialogProperties: {
      type: Object,
      required: true,
    },
  },
};
</script>
